import { createFileRoute } from '@tanstack/react-router'
import { Skeleton } from 'antd'
import { AssetDatabase } from 'pages/assetDatabase/AssetDatabase'
import React, { useMemo } from 'react'
// TODO: ARCH-529
// eslint-disable-next-line boundaries/element-types
import { assetDBSearchSchema } from 'types'

export const Route = createFileRoute('/assets/{-$siteID}/')({
  component: RouteComponent,
  pendingComponent: PendingComponent,
  staticData: {
    title: 'Assets',
  },
  validateSearch: assetDBSearchSchema,
})

// Show skeleton immediately while route is loading/navigating
function PendingComponent() {
  return <Skeleton active paragraph={{ rows: 8 }} style={{ margin: '2rem' }} />
}

function RouteComponent() {
  const search = Route.useSearch()
  const initialFilters = useMemo(
    () => ({
      asset: search.asset,
      lastInspection: search.lastInspection,
      lastUpdated: search.lastUpdated,
      components: search.components,
      area: search.area,
      areaDescription: search.areaDescription,
      erpId: search.erpId,
      criticality: search.criticality,
    }),
    [
      search.asset,
      search.lastInspection,
      search.lastUpdated,
      search.components,
      search.area,
      search.areaDescription,
      search.erpId,
      search.criticality,
    ]
  )

  return (
    <>
      <AssetDatabase initialFilters={initialFilters} />
    </>
  )
}
